module.exports = __webpack_public_path__ + "static/media/Republic-of-Macedonia.dfb5073e.png";